import { useEffect, useState } from "react";
import styled from "styled-components";
import { Row } from "antd";
import { useNotify } from "@utils";
import { useHistory, useParams } from "react-router";
import { PATH_TOP_SPENDER } from "@configs";
import { BackWhiteIcon } from "../icon/TopSpender/BackWhiteIcon";
import { BillIcon } from "../icon/TopSpender/BillIcon";
import { leaderboardAPI } from "src/API/leaderboard";
import { IGetLeaderboard, ILeaderboardDetailData } from "@interfaces";
import { Skeleton } from "antd";
import { deduplicate } from "src/Utils/requestDeduper";

interface IProps {
    userInfo: any;
}
export const ComponentTopSpenderOrderList = (props: IProps) => {
    const { id } = useParams<{ id: string }>();
    const { userInfo } = props;
    const { error } = useNotify();
    const [leaderboard, settLeaderboard] = useState<IGetLeaderboard>();
    const [leaderboardDetail, setLeaderboardDetail] = useState<ILeaderboardDetailData[]>();
    const userContactId = userInfo?.contact?._id;

    const history = useHistory();

    const getLeaderboardDetail = async () => {
        try {
            const get = await deduplicate(`leaderboard-${id}`, () =>
                leaderboardAPI.getleaderboard(id)
            );
            settLeaderboard(get.data);
            const getDetail = await deduplicate(
                `leaderboard-detail-${id}-${userContactId}`,
                () =>
                    leaderboardAPI.getleaderboardDetail({
                        contactId: userContactId,
                        leaderboardIds: id,
                    })
            );
            setLeaderboardDetail(getDetail.data?.docs ? getDetail.data?.docs : []);
        } catch (err: any) {
            err.response?.data?.message ? error(err.response?.data?.message) : error(err.message);
        }
    };

    useEffect(() => {
        if (!id || !userContactId) return;
        window.scrollTo(0, 0);
        getLeaderboardDetail();
    }, [id, userContactId]);
    return leaderboard ? (
        <StyledContainer color={leaderboard?.color ? leaderboard?.color : "#0573cd"}>
            <div className="container">
                <div className="content">
                    <div className="header">
                        <div
                            className="backIcon"
                            onClick={() => history.push(PATH_TOP_SPENDER + "/list/" + id)}
                        >
                            <BackWhiteIcon />
                        </div>
                        <h1>รายการใบเสร็จสั่งซื้อ</h1>
                    </div>
                    <div className="listColumn">
                        {leaderboardDetail?.map((order, i) => (
                            <Row className={`listItemsRow`} key={i}>
                                <div className="leftSide">
                                    <BillIcon
                                        fill={leaderboard?.color ? leaderboard?.color : "#3293DC"}
                                    />
                                    <div className="orderInformation">
                                        <p className="date">{order.date ? order.date : ""}</p>
                                        <p className="name">
                                            {order.store?.nameStore ? order.store?.nameStore : ""}
                                        </p>
                                        <p className="orderID">
                                            ID : {order.receiptId ? order.receiptId : ""}
                                        </p>
                                    </div>
                                </div>
                                <div className="rightSide">
                                    <p>{order.amount ? order.amount : 0} บาท</p>
                                </div>
                            </Row>
                        ))}
                    </div>
                </div>
            </div>
        </StyledContainer>
    ) : (
        <Skeleton />
    );
};
const StyledContainer = styled.div<{ color: string }>`
    .container {
        .backIcon {
            position: absolute;
            left: 20px;
            cursor: pointer;
        }
        background: ${(p) => p.color};
        .ant-divider {
            background: #e1e1e1;
            width: 90%;
            min-width: 90%;
            margin: auto;
            margin: 22px auto 16px auto;
        }
    }
    .topHeaderImage {
        width: 100%;
    }
    .content {
        .header {
            position: relative;
            display: flex;
            flex-direction: row;
            place-content: center;
            padding: 60px 16px 16px 16px;
        }
        h1 {
            color: #fff;
            font-size: 24px;
            font-style: normal;
            font-weight: 700;
            line-height: inherit;
        }
        .listColumn {
            display: flex;
            flex-direction: column;
            gap: 6px;
            overflow: auto;
            position: relative;
            border-radius: 16px 16px 0px 0px;
            background: #fff;
            padding: 12px 20px;
            th {
                color: #000;
                font-size: 14px;
                font-style: normal;
                font-weight: 700;
                line-height: inherit;
            }
            .ant-row {
                padding: 6px 20px;
            }
            .listItemsRow {
                border-radius: 12px;
                background: rgba(50, 147, 220, 0.04);
                padding: 12px 20px;
                display: flex;
                place-items: center;
                .leftSide {
                    display: flex;
                    gap: 12px;
                    flex-direction: row;
                    .orderInformation {
                        p {
                            margin: 0;
                            color: #000;
                            font-size: 12px;
                            font-style: normal;
                            font-weight: 400;
                            line-height: 20px;
                        }
                        .date,
                        .orderID {
                            font-size: 12px;
                        }
                        .name {
                            font-size: 14px;
                        }
                    }
                }
                .rightSide {
                    display: flex;
                    margin-left: auto;
                    gap: 6px;
                    align-items: center;
                    place-items: center;
                    p {
                        color: ${(p) => p.color};
                        font-size: 16px;
                        font-style: normal;
                        font-weight: 700;
                        line-height: inherit;
                        margin: 0;
                        top: -2px;
                        position: relative;
                    }
                }
            }
        }
    }
`;
